var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ik-data-table',{ref:"table",staticStyle:{"width":"100%"},attrs:{"entity-name":"repertory","model":_vm.model,"icon":"mdi-label"},on:{"reloaded":_vm.reloaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }